import { RouteConfig } from "@/routes/routes";

import { chatRoutes } from "@/features/chat/routes";

export const routes: RouteConfig[] = [...chatRoutes];
